"use client";
import { Realtime } from "ably";

let ablyClient: Realtime | null = null;

let subscriberCount = 0;

export const getAblyClient = () => {
  if (!ablyClient) {
    console.log("@getAblyClient", subscriberCount);
    ablyClient = new Realtime({
      authUrl: `${process.env.NEXT_PUBLIC_URL}/api/ably/createTokenRequest`,
    });
    ablyClient.connection.on((stateChange) => {
      console.log("Previous state: " + stateChange.previous);
      console.log("Current state: " + stateChange.current);
      console.log("Reason: ", stateChange.reason);
    });
  }
  subscriberCount += 1;
  return ablyClient;
};

export const releaseAblyClient = () => {
  console.log("@@@@releaseAblyClient");
  subscriberCount -= 1;
  if (subscriberCount <= 0 && ablyClient) {
    ablyClient.close();
    ablyClient = null;
    subscriberCount = 0;
  }
};

// @see: https://github.com/ably/ably-js/issues/1562
